import React, { useState, useEffect, useContext } from "react";
import styles from "./NewNavbar.module.sass";
import { NavLink, useNavigate } from "react-router-dom";
// import LazyLoad from "react-lazyload";
import { useScrollLock } from "../../hooks/lockScroll";
// import { IKImage } from "imagekitio-react";
import { GlobalContext } from "src/GlobalContext";
import Logo from "../../images/logo.png";
import InnerLogo from "../../images/innerLogo.png";
export default function NewNavbar({
  variant,
  navItems,
  logo,
  innerLogo,
  whiteExpansion,
}) {
  const navigate = useNavigate();
  // console.log("nav--", navItems);
  // states-----
  const { lockScroll, unlockScroll } = useScrollLock();
  const [showNav, setshowNav] = useState(false);
  const [width, setwidth] = useState(window.innerWidth);
  const [isHovering, setIsHovering] = useState(false);
  const [isSpeakerHovering, setIsSpeakerHovering] = useState(false);
  const [resExpansionIsOpen, setresExpansionIsOpen] = useState(false);
  const [speakerResExpansionIsOpen, setSpeakerResExpansionIsOpen] =
    useState(false);
  const [isFixed, setIsFixed] = useState(false);
  const [dropdownActive, setdropdownActive] = useState(false);
  const { eventYear } = useContext(GlobalContext);
  // const [whiteExpansion, setwhiteExpansion] = useState(true);
  const [showLogo, setShowLogo] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setShowLogo(true);
    }, 500);

    return () => clearTimeout(timeout);
  }, [variant]);
  useEffect(() => {
    // Handle route change here and update logo accordingly
    setShowLogo(false); // Hide the logo when the route changes
  }, [window.location.pathname]);
  useEffect(() => {
    if (showNav) {
      lockScroll();
    } else {
      unlockScroll();
      setresExpansionIsOpen(false);
      setSpeakerResExpansionIsOpen(false);
    }
  }, [showNav]);

  // -------

  //--------api calls----
  //--------
  function responsiveExpansionHandler() {
    if (width <= 1024) {
      setresExpansionIsOpen(!resExpansionIsOpen);
    }
  }
  function speakerResponsiveExpansionHandler() {
    if (width <= 1024) {
      setSpeakerResExpansionIsOpen(!speakerResExpansionIsOpen);
    }
  }
  function onClosehandler(e) {
    setshowNav(false);
    e.preventDefault();
  }
  useEffect(() => {
    function handleResize() {
      setwidth(window.innerWidth);
    }

    window.addEventListener("resize", handleResize);
    // fetchNavigation();
    // fetchInnerLogo();
  }, []);
  useEffect(() => {
    function handleScroll() {
      if (window.scrollY > 0) {
        setIsFixed(true);
      } else {
        setIsFixed(false);
      }
    }
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <div
      className={
        variant === "white"
          ? styles.wholeContainerWhite
          : variant !== "white" && isFixed && width > 1024
          ? styles.wholeContainerWhite
          : styles.wholeContainer
      }
      style={{
        transition: showNav && width <= 1024 ? "none" : null,
        backgroundColor:
          showNav && width <= 1024
            ? "rgba(0, 0, 0,0.8)"
            : isFixed && width > 1024
            ? "#fff"
            : null,
      }}
    >
      <div className={styles.container}>
        <div className={styles.logo}>
          <NavLink
            className={styles.image}
            onClick={(e) => {
              setshowNav(false);
              navigate("/");
              e.preventDefault();
            }}
          >
            {/* <LazyLoad> */}
            {!showNav ? (
              variant === "white" || (isFixed === true && width > 1024) ? (
                <img
                  src={
                    innerLogo
                      ? `${process.env.REACT_APP_API_SERVER_URL}/${innerLogo}`
                      : InnerLogo
                  }
                  alt="Site logo"
                  height="50"
                  width="200"
                  loading="lazy"
                />
              ) : (
                showLogo && (
                  <img
                    src={
                      logo
                        ? `${process.env.REACT_APP_API_SERVER_URL}/${logo}`
                        : Logo
                    }
                    alt="Site logo"
                    height="50"
                    width="200"
                    loading="lazy"
                  />
                )
              )
            ) : (
              showLogo && (
                <img
                  src={
                    logo
                      ? `${process.env.REACT_APP_API_SERVER_URL}/${logo}`
                      : Logo
                  }
                  alt="Site logo"
                  height="50"
                  width="200"
                  loading="lazy"
                />
              )
            )}
          </NavLink>
        </div>
        <div
          className={
            showNav
              ? `${styles.navLinksContainer}`
              : `${styles.hide} ${styles.navLinksContainer}`
          }
        >
          <div
            className={styles.linksContainer}
            style={
              (resExpansionIsOpen || speakerResExpansionIsOpen) && width <= 1024
                ? { flexDirection: "row", flexWrap: "nowrap" }
                : null
            }
          >
            {(resExpansionIsOpen || speakerResExpansionIsOpen) &&
            width <= 1024 ? (
              <NavLink
                style={{
                  width: "60px",
                  marginRight: "10px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                onClick={
                  resExpansionIsOpen
                    ? responsiveExpansionHandler
                    : speakerResponsiveExpansionHandler
                }
              >
                {" "}
                <img
                  src="./images/icons/left-arrow.png"
                  alt="left icon"
                  width="12"
                />{" "}
              </NavLink>
            ) : null}
            {navItems &&
              navItems.map((v, i) => {
                if (i === 0 && v.link === "/home") {
                  return (
                    <NavLink
                      key={i}
                      onMouseEnter={() => setIsHovering(true)}
                      onMouseLeave={() => setIsHovering(false)}
                      onClick={() => setresExpansionIsOpen(true)}
                      style={{
                        width:
                          resExpansionIsOpen && width <= 1024 ? "100%" : null,
                        display:
                          speakerResExpansionIsOpen && width <= 1024
                            ? "none"
                            : null,
                      }}
                    >
                      Event Details
                      {isHovering && width > 1024 ? (
                        <div
                          className={`${
                            whiteExpansion
                              ? styles.expansionMenuWhite
                              : styles.expansionMenu
                          }`}
                        >
                          <NavLink
                            onClick={(e) => {
                              setshowNav(false);
                              navigate("/booking");
                              setdropdownActive(true);
                              e.preventDefault();
                            }}
                          >
                            Register & Book Now
                          </NavLink>
                          <NavLink
                            onClick={(e) => {
                              setshowNav(false);
                              navigate("/agenda-page");
                              setdropdownActive(true);
                              e.preventDefault();
                            }}
                          >
                            {`Program ${eventYear && eventYear}`}
                          </NavLink>
                          <NavLink
                            onClick={(e) => {
                              setshowNav(false);
                              navigate("/who-should-attend");
                              setdropdownActive(true);
                              e.preventDefault();
                            }}
                          >
                            Who Should Attend
                          </NavLink>
                          <NavLink
                            onClick={(e) => {
                              setshowNav(false);
                              navigate("/faq");
                              setdropdownActive(true);
                              e.preventDefault();
                            }}
                          >
                            FAQ
                          </NavLink>
                        </div>
                      ) : resExpansionIsOpen && width <= 1024 ? (
                        <div className={styles.resExpansionMenu}>
                          <NavLink
                            onClick={(e) => {
                              setshowNav(false);
                              navigate("/booking");
                              e.preventDefault();
                            }}
                          >
                            Register & Book Now
                          </NavLink>
                          <NavLink
                            onClick={(e) => {
                              setshowNav(false);
                              navigate("/agenda-page");
                              e.preventDefault();
                            }}
                          >
                            {`Program ${eventYear && eventYear}`}
                          </NavLink>
                          <NavLink
                            onClick={(e) => {
                              setshowNav(false);
                              navigate("/who-should-attend");
                              e.preventDefault();
                            }}
                          >
                            Who Should Attend
                          </NavLink>
                          <NavLink
                            onClick={(e) => {
                              setshowNav(false);
                              navigate("/faq");
                              e.preventDefault();
                            }}
                          >
                            FAQs
                          </NavLink>
                        </div>
                      ) : null}
                    </NavLink>
                  );
                } else if (i === 1 && v.link === "/speakers") {
                  return (
                    <NavLink
                      key={i}
                      onMouseEnter={() => setIsSpeakerHovering(true)}
                      onMouseLeave={() => setIsSpeakerHovering(false)}
                      onClick={() => setSpeakerResExpansionIsOpen(true)}
                      style={{
                        width:
                          speakerResExpansionIsOpen && width <= 1024
                            ? "100%"
                            : null,

                        display:
                          resExpansionIsOpen && width <= 1024 ? "none" : null,
                      }}
                    >
                      Speakers
                      {isSpeakerHovering && width > 1024 ? (
                        <div
                          className={`${
                            whiteExpansion
                              ? styles.expansionMenuWhite
                              : styles.expansionMenu
                          }`}
                        >
                          <NavLink
                            onClick={(e) => {
                              setshowNav(false);
                              navigate("/speakers");
                              setdropdownActive(true);
                              e.preventDefault();
                            }}
                          >
                            Call for Presentations
                          </NavLink>
                          <NavLink
                            onClick={(e) => {
                              setshowNav(false);
                              navigate("/featured-speakers");
                              setdropdownActive(true);
                              e.preventDefault();
                            }}
                          >
                            Featured Speakers
                          </NavLink>
                        </div>
                      ) : speakerResExpansionIsOpen && width <= 1024 ? (
                        <div className={styles.resExpansionMenu}>
                          <NavLink
                            onClick={(e) => {
                              setshowNav(false);
                              navigate("/speakers");
                              e.preventDefault();
                            }}
                          >
                            Call for Presentations
                          </NavLink>
                          <NavLink
                            onClick={(e) => {
                              setshowNav(false);
                              navigate("/featured-speakers");
                              e.preventDefault();
                            }}
                          >
                            Featured Speakers
                          </NavLink>
                        </div>
                      ) : null}
                    </NavLink>
                  );
                } else if (i === 0) {
                  return <NavLink to={v.link}>{v.label}</NavLink>;
                } else {
                  null;
                }
              })}
            {(resExpansionIsOpen || speakerResExpansionIsOpen) &&
            width <= 1024 ? null : (
              <>
                {navItems &&
                  navItems?.map((v, i) => {
                    if (i !== 0 && i !== 1) {
                      return (
                        <NavLink
                          key={i}
                          to={v.link}
                          // onClick={onClosehandler}
                          className={({ isActive }) =>
                            isActive ? styles.active : ""
                          }
                          onClick={(e) => {
                            setshowNav(false);
                            setdropdownActive(false);
                            navigate(v.link);
                            e.preventDefault();
                          }}
                        >
                          {v.label}
                        </NavLink>
                      );
                    } else {
                      null;
                    }
                  })}
                <button
                  className={styles.btnResponsive}
                  onClick={(e) => {
                    setshowNav(false);
                    navigate("/booking");
                    e.preventDefault();
                  }}
                >
                  Register
                </button>
              </>
            )}
          </div>
        </div>
        <div className={styles.register}>
          <button
            onClick={(e) => {
              setshowNav(false);
              navigate("/booking");
              e.preventDefault();
            }}
            className={styles.btn}
          >
            Register
          </button>
          {showNav == false ? (
              <svg
              width="33"
              height="28"
              viewBox="0 0 33 28"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              onClick={() => setshowNav(!showNav)}
            >
              <rect width="33" height="6" />
              <rect y="11" width="33" height="6" />
              <rect y="22" width="33" height="6" />
            </svg>
          ) : (
            <img
              src="./images/icons/close-white.png"
              alt="Hamburger icons"
              onClick={() => setshowNav(!showNav)}
              className={styles.close}
              width="25"
              height="25"
            />
          )}
        </div>
      </div>
    </div>
  );
}
